<app-tab
	[tabs]="beneTabs"
	[navTab]="activeTab"
	(action)="onTabClick($event)"
></app-tab>

<aside [attr.id]="isSanusMode ? 'sanus-menu' : 'default-menu'">
	<ng-container *ngIf="!isSanusMode; else sanusModeContent">
		<button
			id="new-beneficiary"
			mat-flat-button
			color="primary"
			(click)="onNewBeneficiary()"
		>
			<mat-icon>add</mat-icon>
			<span class="no-mob">Novo beneficiário</span>
		</button>
		<div class="d-f jc-fe ai-c mb-xxs">
			<p class="fs-xxs mr-nano">Beneficiários ativos:</p>
			<button mat-button color="primary" (click)="onActiveDataDownload()">
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Relatório</span>
			</button>
		</div>
	</ng-container>

	<ng-template #sanusModeContent>
		<button
			id="new-beneficiary"
			mat-flat-button
			color="primary"
			(click)="onNewBeneficiary()"
		>
			<mat-icon>add</mat-icon>
			<span class="no-mob">Novo beneficiário</span>
		</button>

		<span id="mass-inclusion" class="action-group">
			<mat-icon color="accent">cloud_upload</mat-icon>
			<span id="icon-labeled">
				<p>Inclusão em massa:</p>
			</span>
			<button
				mat-button
				color="primary"
				(click)="onFileDownload(actionType.INCLUSION)"
			>
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Modelo</span>
			</button>
			<span class="import-file">
				<label class="button import-file-label" for="inputInclusion">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<p>Importar Arquivo</p>
				</label>
				<input
					#fileInputInclusion
					class="file-input"
					type="file"
					id="inputInclusion"
					[multiple]="false"
					(change)="onFileUpload(actionType.INCLUSION, $event)"
				/>
			</span>
		</span>

		<span id="mass-update" class="action-group">
			<mat-icon [ngStyle]="{ color: 'orange' }">update</mat-icon>
			<span id="icon-labeled">
				<p>Atualização em massa:</p>
			</span>
			<button
				mat-button
				color="primary"
				(click)="onFileDownload(actionType.UPDATE)"
			>
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Modelo</span>
			</button>
			<span class="import-file">
				<label class="button import-file-label" for="inputUpdate">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<p>Importar Arquivo</p>
				</label>
				<input
					#fileInputUpdate
					class="file-input"
					type="file"
					id="inputUpdate"
					[multiple]="false"
					(change)="onFileUpload(actionType.UPDATE, $event)"
				/>
			</span>
		</span>
		<span id="mass-transfer" class="action-group">
			<mat-icon [ngStyle]="{ color: 'dodgerblue' }">swap_horiz</mat-icon>
			<span id="icon-labeled">
				<p>Transferência em massa:</p>
			</span>
			<button
				mat-button
				color="primary"
				(click)="onFileDownload(actionType.TRANSFER)"
			>
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Modelo</span>
			</button>
			<span class="import-file">
				<label class="button import-file-label" for="inputTransfer">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<p>Importar Arquivo</p>
				</label>
				<input
					#fileInputTransfer
					class="file-input"
					type="file"
					id="inputTransfer"
					[multiple]="false"
					(change)="onFileUpload(actionType.TRANSFER, $event)"
				/>
			</span>
		</span>

		<span id="mass-exclusion" class="action-group">
			<mat-icon color="warn">delete_forever</mat-icon>
			<span id="icon-labeled">
				<p>Exclusão em massa:</p>
			</span>
			<button
				mat-button
				color="primary"
				(click)="onFileDownload(actionType.EXCLUSION)"
			>
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Modelo</span>
			</button>
			<span class="import-file">
				<label class="button import-file-label" for="inputExclusion">
					<mat-icon svgIcon="sanus-upload"></mat-icon>
					<p>Importar Arquivo</p>
				</label>
				<input
					#fileInputExclusion
					class="file-input"
					type="file"
					id="inputExclusion"
					[multiple]="false"
					(change)="onFileUpload(actionType.EXCLUSION, $event)"
				/>
			</span>
		</span>

		<span id="download-report">
			<mat-icon [ngStyle]="{ color: 'grey' }">list_alt</mat-icon>
			<span id="icon-labeled">
				<p>Beneficiários ativos:</p>
			</span>
			<button mat-button color="primary" (click)="onActiveDataDownload()">
				<mat-icon svgIcon="sanus-download"></mat-icon>
				<span>Baixar Relatório</span>
			</button>
		</span>
	</ng-template>
</aside>

<section id="search" [formGroup]="searchForm">
	<mat-form-field title="Busca de beneficiários" appearance="outline">
		<mat-label>Busca de beneficiários</mat-label>
		<input
			type="text"
			matInput
			placeholder="Busca de beneficiários"
			formControlName="term"
			id="sms-{{ inputId }}"
			(keyup)="onSearchKeyUp($event)"
		/>
		<button
			*ngIf="!searchButton"
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Clear search"
			(click)="onClearSearch()"
		>
			<mat-icon>close</mat-icon>
		</button>
		<button
			*ngIf="searchButton"
			matSuffix
			mat-icon-button
			color="primary"
			aria-label="Search beneficiaries"
			[disabled]="isSearchButtonDisabled"
			(click)="getBeneficiaries({ hideSearchBtn: true })"
		>
			<mat-icon>search</mat-icon>
		</button>
	</mat-form-field>
</section>

<section class="table">
	<table
		matSort
		mat-table
		[dataSource]="isLoading ? [] : beneficiaries"
		(matSortChange)="onSortData($event)"
	>
		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef>Status</th>
			<td mat-cell *matCellDef="let element">
				<ng-container *ngIf="!isLoading">
					<span
						class="badge"
						[class]="processStatusCssClass(element.pendency)"
						(click)="onPendencyDialogOpen($event, element.id, element.status)"
						(keyup)="onPendencyDialogOpen($event, element.id, element.status)"
						tabindex="0"
					>
						{{ processedStatus(element.pendency) }}
					</span>
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="name">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.NAME"
				sortActionDescription="Ordenar por nome"
			>
				Nome
			</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ element.user.name }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="phone">
			<th mat-header-cell *matHeaderCellDef>Telefone</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{
						element?.user?.phone
							? (element.user.phone | mask: phoneMask(element.user.phone))
							: nullPlaceholder
					}}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="cpf">
			<th mat-header-cell *matHeaderCellDef>CPF</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer text-wrap-nowrap"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.user.cpf | mask: cpfMask }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="createdAt">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.CREATION_DATE"
				sortActionDescription="Ordenar por data de cadastro"
			>
				Cadastro
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.user.created_at | date: 'dd/MM/YYYY' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="type">
			<th mat-header-cell *matHeaderCellDef>Tipo</th>
			<td
				mat-cell
				*matCellDef="let element"
				class="pointer"
				(click)="onEditBeneficiary(element.id)"
				(keydown)="onEditBeneficiary(element.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ isBeneficiaryHolder(element) ? 'Titular' : 'Dependente' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="exclusionDate">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.EXCLUSION_DATE"
				sortActionDescription="Ordenar por data de exclusão"
			>
				Exclusão
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.exclusionDate | date: 'dd/MM/YYYY' }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="dependentCount">
			<th
				mat-header-cell
				*matHeaderCellDef
				id="dependents"
				class=".padding-zero-h"
			>
				Dependentes
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{ beneficiary.countDependents }}
				</ng-container>
			</td>
		</ng-container>

		<ng-container matColumnDef="removedFromInsurance">
			<th
				mat-header-cell
				*matHeaderCellDef
				[mat-sort-header]="beneficiariesFieldOrdinationEnum.INACTIVATION_DATE"
				sortActionDescription="Ordenar por data de inativação"
			>
				Inativação
			</th>
			<td
				mat-cell
				*matCellDef="let beneficiary"
				class="pointer"
				(click)="onEditBeneficiary(beneficiary.id)"
				(keydown)="onEditBeneficiary(beneficiary.id)"
			>
				<ng-container *ngIf="!isLoading">
					{{
						beneficiary.insuranceInactivatedAt
							? (beneficiary.insuranceInactivatedAt | date: 'dd/MM/yyyy')
							: nullPlaceholder
					}}
				</ng-container>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="tableColumnsShown"></tr>
		<tr mat-row *matRowDef="let row; columns: tableColumnsShown"></tr>
	</table>

	<ng-container *ngIf="isLoading; else dataOrEmpty">
		<mat-spinner diameter="48"></mat-spinner>
	</ng-container>

	<ng-template #dataOrEmpty>
		<div class="table-empty" *ngIf="!hasBeneficiaries()">
			<p *ngIf="!getWithSearchTerm">
				Nenhum beneficiário {{ selectedLabel }} cadastrado
			</p>
			<p *ngIf="getWithSearchTerm">
				Nenhum resultado encontrado, verifique os termos digitados e busque
				novamente
			</p>
		</div>
	</ng-template>

	<mat-paginator
		showFirstLastButtons
		[pageSizeOptions]="[10, 20, 50, 100]"
		[length]="tableTotalItems"
		(page)="onChangePage($event)"
	></mat-paginator>
</section>
